function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C11.4477 0 11 0.447716 11 1V14.5859L7.71875 11.3047C7.32827 10.9142 6.69517 10.9142 6.30469 11.3047C5.91421 11.6952 5.91421 12.3283 6.30469 12.7188L11.2826 17.6967C11.2947 17.7091 11.3071 17.7212 11.3197 17.733C11.7118 18.0993 12.3267 18.0913 12.709 17.709L12.71 17.708L12.7109 17.707L17.7051 12.7129C18.0956 12.3224 18.0956 11.6893 17.7051 11.2988C17.3146 10.9083 16.6815 10.9083 16.291 11.2988L13 14.5898V1C13 0.447715 12.5523 0 12 0ZM0 10C0 6.68629 2.68629 4 6 4H7C7.55228 4 8 4.44772 8 5C8 5.55228 7.55228 6 7 6H6C3.79086 6 2 7.79086 2 10V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V10C22 7.79086 20.2091 6 18 6H17C16.4477 6 16 5.55228 16 5C16 4.44772 16.4477 4 17 4H18C21.3137 4 24 6.68629 24 10V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V10Z",
  fill: "#5AE6D9"
});

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.c2d3ddd4.svg";
export { ForwardRef as ReactComponent };